import { useEffect, useState } from 'react'
import { EventSegment, MoreLinkArg } from '@fullcalendar/core'
import { format } from 'date-fns'
import { Locale } from 'date-fns/locale'
import { getLocalFromLanguage } from '@/modules/helper/languageHelper.ts'
import { EventCalendar } from '@/types/Calendar.ts'

export function useRemoveFcPopover(): void {
    useEffect(() => {
        const observer: MutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
            mutations.forEach((mutation: MutationRecord) => {
                mutation.addedNodes.forEach((node: Node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const element: Element = node as Element
                        if (element.classList?.contains('fc-popover')) {
                            element.remove()
                        }
                    }
                })
            })
        })

        observer.observe(document.body, { childList: true, subtree: true })

        return () => observer.disconnect()
    }, [])
}

export function getDraftingRoute(sectionGroupId: number, start: string): string {
    return `/drafting?id=${sectionGroupId}&date=${start}`
}

function handleMoreLinkClickHelper(info: MoreLinkArg): EventCalendar[] {
    return info.allSegs.map((seg: EventSegment) => ({
        ...(seg.event.extendedProps as EventCalendar),
        title: seg.event.title,
        start: seg.event.start,
        end: seg.event.end,
        id: seg.event.id
    })) as EventCalendar[]
}

interface UseMoreLinkDialogReturn {
    openMoreLinkDialog: boolean
    setOpenMoreLinkDialog: (open: boolean) => void
    moreLinkEvents: EventCalendar[]
    setMoreLinkEvents: (events: EventCalendar[]) => void
    moreLinkDate: string
    handleMoreLinkClick: (info: MoreLinkArg) => string
}

export function useMoreLinkDialog(): UseMoreLinkDialogReturn {
    const [openMoreLinkDialog, setOpenMoreLinkDialog] = useState<boolean>(false)
    const [moreLinkEvents, setMoreLinkEvents] = useState<EventCalendar[]>([])
    const [moreLinkDate, setMoreLinkDate] = useState<string>('')

    const handleMoreLinkClick: (info: MoreLinkArg) => string = (info: MoreLinkArg): string => {
        const dayEvents: EventCalendar[] = handleMoreLinkClickHelper(info)
        const locale: Locale = getLocalFromLanguage()

        setMoreLinkEvents(dayEvents)
        setMoreLinkDate(format(info.date, 'EEEE dd MMMM yyyy', { locale }))
        setOpenMoreLinkDialog(true)

        return 'popover'
    }

    return {
        openMoreLinkDialog,
        setOpenMoreLinkDialog,
        moreLinkEvents,
        setMoreLinkEvents,
        moreLinkDate,
        handleMoreLinkClick
    }
}
